module.exports = __webpack_public_path__ + "img/pijltjes-secundaire-button-wit.3d39848628fb81f5644bc2bd73cc5b58.svg";